import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon, Star } from 'lucide-react';
export function Mapa3DSection() {
  const pillars = [{
    icon: <Sun className="w-8 h-8 text-amber-400" data-id="element-116" />,
    title: '1) DÍA',
    desc: 'Ajustas ventanas de vigilia y siestas para que llegue a la noche con el cansancio correcto. Ni subcansado, ni pasado de sueño.'
  }, {
    icon: <Moon className="w-8 h-8 text-indigo-300" data-id="element-117" />,
    title: '2) DORMIDA',
    desc: 'Instalas un ritual corto que el bebé reconoce. Y un ambiente que deja de sabotearte.'
  }, {
    icon: <Star className="w-8 h-8 text-purple-300" data-id="element-118" />,
    title: '3) DESPERTARES',
    desc: 'Tienes una escalera de ayuda y guiones 2am. Para acompañar sin reforzar el mismo ciclo cada vez.'
  }];
  return <section className="py-24 px-4 bg-gradient-to-b from-[#111c35] to-[#0c1425]" data-id="element-119">
      <div className="max-w-5xl mx-auto" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-121">
          <h2 className="text-3xl md:text-5xl font-serif text-cream mb-4" data-id="element-122">
            Aquí entra el Mapa 3D
          </h2>
          <p className="text-xl text-amber-200/80" data-id="element-123">
            En vez de preguntarte "¿qué hago cuando llora?", vas a tener 3
            palancas:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-124">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-[#1a2744] border border-white/5 rounded-2xl p-8 hover:border-amber-500/30 transition-colors duration-300" data-id="element-125">
              <div className="bg-[#0c1425] w-16 h-16 rounded-full flex items-center justify-center mb-6 shadow-lg shadow-black/20" data-id="element-126">
                {pillar.icon}
              </div>
              <h3 className="text-2xl font-serif text-cream mb-4" data-id="element-127">
                {pillar.title}
              </h3>
              <p className="text-amber-100/70 leading-relaxed" data-id="element-128">{pillar.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-129">
          <p className="text-xl md:text-2xl font-serif italic text-amber-400/90" data-id="element-130">
            "Esto es lo que hace que el método sea gentil y práctico al mismo
            tiempo."
          </p>
        </motion.div>
      </div>
    </section>;
}